import humanizeDuration from "humanize-duration";
import type { Moment } from "moment-timezone";
import moment from "moment-timezone";
import { getUserLanguage } from "./userFunctions";

const defaultTimeZoneFormat = "Z z";

export const defaultDateFormat = "L";
export const defaultDateTimeFormat = "L LT";
export const defaultTimeFormat = "LT";

export const formatDateTime = (dateTime: Moment, timeZone: string) =>
    dateTime?.tz(timeZone)?.format(defaultDateTimeFormat);

export const formatTimeZone = (timeZone: string, dateTime?: Moment) => {
    const dt = (dateTime ?? moment()).tz(timeZone);
    return `${dt.tz()}, ${dt.format(defaultTimeZoneFormat)}`;
};

export const humanizeDateTime = (dateTime: Moment) => {
    if (!moment.isMoment(dateTime)) {
        return "";
    }
    const lang = getUserLanguage();
    return humanizeDuration(moment.duration(moment().diff(dateTime)).asMilliseconds(), {
        language: lang,
        largest: 1,
        round: true,
        units: ["y", "mo", "w", "d", "h", "m"],
    }) as string;
};

export const humanizeSeconds = (seconds: number) => {
    if (typeof seconds !== "number" || seconds < 0) {
        return "";
    }
    const lang = getUserLanguage();
    return humanizeDuration(seconds * 1000, {
        language: lang,
        largest: 1,
        round: true,
        units: ["y", "mo", "w", "d", "h", "m"],
    }) as string;
};

export const humanizeMilliseconds = (ms: number) => {
    if (!ms) {
        return "";
    }
    const lang = getUserLanguage();
    return humanizeDuration(ms, {
        language: lang,
        largest: 1,
        round: true,
        units: ["h", "m", "s"],
    }) as string;
};
